import { getInquiry } from "./getInquiry";
import { postInquiry } from "./postInquiry";
import { deleteInquiry } from "./deleteInquiry";

export const InquiryApi = {
  getInquiry,
  postInquiry,
  deleteInquiry
};
